export const eventListTemplate = (() => { 
    function getHitTemplate(hit, firstHitId, noStyle) {
        const tags = hit.eventCategories.map(cat => `<span>${cat}</span>`).join('') + 
                `<span class="event-type event-type-${hit.eventType}">${hit.eventTypeDesc}</span>`; 

            const tagbottoms = (hit.datePeriod != null ? `<span class='tag-date'>${hit.datePeriod}</span>` : '') +
                (hit.location != null ? `<span class='tag-location'>${hit.location}</span>` : '') +
                (hit.hasAccess ? '' : '<span class="tag-locked">Bara för medlemmar</span>');

            let cssPartClass = hit.eventType == 0 ? '--red' : '--green';   

            firstHitId = firstHitId === null ? hit.url : firstHitId;  
            cssPartClass = firstHitId === hit.url ? '--first' + cssPartClass : cssPartClass;
            const url = hit.hasAccess ? hit.url : `preview?id=${hit.id}`;    

            const hasImgClass = hit.imageSrc.length ? ' has-event-image' : '';
            let hasImgStyle = (firstHitId != hit.url && hit.imageSrc.length) ? `background-image:url(/Sites/Public/dist/images/circle-transp.svg), url(${hit.imageSrc}?width=470&height=780&rmode=crop&rsampler=bicubic&compand=true&rxy=0.4,0.5);` : '';

            let firstFigure = '';
            if (firstHitId === hit.url && hit.imageSrc.length && !noStyle) {
                const imgUrl = `${hit.imageSrc}?width=590&height=417&rmode=crop&rsampler=bicubic&compand=true&rxy=0.3,0.7`;
                const maskId = `event-first-mask-${hit.id}`;
                firstFigure = `<svg class="event-list__item--first-figure" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="100%" height="100%" viewBox="0 0 725 505" preserveAspectRatio="xMidYMid meet" aria-hidden="true"><defs><clipPath id="${maskId}" clipPathUnits="userSpaceOnUse"><path d="M725,119.8c-7.34-1.69-14.12-5.89-19.03-12.21-32.67-42.11-79.97-73.19-136.3-84.65-28.53-5.8-56.88-6.04-83.97-1.5-14.79,2.48-29.45-4.98-35.9-18.52l-1.39-2.92h-65.9l11.71,24.61c6.8,14.28,2.36,31.19-10.23,40.75-43.12,32.71-74.99,80.63-86.63,137.84-7.25,35.62-5.83,70.98,2.75,103.93,4.01,15.4-3.65,31.45-18.02,38.29l-56.63,30.71c-11.66,5.55-25.53,3.94-35.46-4.31-14.25-11.83-31.54-20.42-50.97-24.36-63.03-12.76-125.34,29.34-137.07,92.57-4.2,22.66-1.5,45.05,6.66,64.97h214.81c1.04-2.56,2-5.18,2.86-7.84,3.97-12.27,5.79-24.61,5.72-36.65-.07-13.08,7.21-25.07,19.02-30.69l62.3-33.41c13.39-6.37,29.29-3.07,39.24,7.93,32.95,36.4,77.77,62.67,130.06,72.13,98.42,17.8,195.26-30.77,242.37-114.36V119.8Z"/></clipPath></defs><image width="100%" height="100%" preserveAspectRatio="xMidYMid slice" clip-path="url(#${maskId})" href="${imgUrl}" xlink:href="${imgUrl}"/></svg>`;
            }
            if (noStyle) {
                hasImgStyle = '';
            }

        // In hero mode (noStyle=true), don't wrap in <a> tag, only the button links
        if (noStyle) {
            return `
                <div class="event-list__item event-list__item${cssPartClass}${hasImgClass}" style="${hasImgStyle}">
                    ${firstFigure}
                    <div class="event-tags">${tags}</div>
                    <h3>${hit.name}</h3>
                    <p>${hit.preamble}</p>
                    <div class="tag-bottoms">${tagbottoms}</div>
                    <div class="event-list__item--cta"><a href="${url}"><button class="btn btn--alert">Läs mer och anmäl</button></a></div>
                </div>
            `;
        }

        // Regular list mode - keep wrapping <a> tag
        return `
                <a href="${url}" class="event-list__item event-list__item${cssPartClass}${hasImgClass}" style="${hasImgStyle}">
                    ${firstFigure}
                    <div class="event-tags">${tags}</div>
                    <h3>${hit.name}</h3>
                    <p>${hit.preamble}</p>
                    <div class="tag-bottoms">${tagbottoms}</div>
                    <div class="event-list__item--cta"><button class="btn btn--alert">Läs mer och anmäl</button></div>
                </a>
            `;
    }

    return {
        getHitTemplate
    };

})();

export const eventList = (() => {

    const eventblock = document.getElementById('event-block')
    if (!eventblock) return;

    const eventList = eventblock.querySelector('.js-event-list');
    const eventTotalEls = eventblock.querySelectorAll('.js-total-items');
    const eventVisibleEls = eventblock.querySelectorAll('.js-visible-items');
    const loadMoreBtn = eventblock.querySelector('.js-loadmore');
    const progressBar = eventblock.querySelector('.progress-bar');
    const eventListFooter = eventblock.querySelector('.event-list__footer'); 

    let firstHitId = null;
    let page = 1;
    let isFirstFetch = true;
    let isLoading = false;

    function fetchPage(clearhits) {
        const { endpoint } = fetchPage.init(clearhits);

        fetch(endpoint, {
            method: "GET",
        }).
        then((response) => {
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }
            return response.json();
        }).
        then((data) => {
            fetchPage.updateHitsAndFilters(data, clearhits);
            fetchPage.updateCounterEls(data);
            if (isFirstFetch) {
                fetchPage.handleSlider(data);
            }
            isFirstFetch = false;
            isLoading = false;
            page++;

        })
        .catch((error) => {
            console.error('Error fetching events:', error);
            isLoading = false;
        });
    }

    fetchPage.init = function(clearhits) {
        if (clearhits) {
            page = 1;
        }

        const form = document.getElementsByClassName('js-eventfilter')[0];
        const formData = new FormData(form);
        const queryString = new URLSearchParams(formData).toString();
        const endpoint = `/api/events/list?page=${page}&${queryString}`;
        isLoading = true;
        eventListFooter.classList.add('hidden');

        return { endpoint }; // TODO: Check this
    };

    fetchPage.updateHitsAndFilters = function(data, clearhits) {
        if (clearhits) {
            eventList.innerHTML = '';
        }
        addHits(data.items);
        if(isFirstFetch) {
            addDynamicFilters(data.facets);
            addEvents();
        }
    };

    fetchPage.updateCounterEls = function(data) {
        eventTotalEls.forEach(el => el.textContent = data.totalMatching);

        const visibleCount = eventList.querySelectorAll('a').length;
        eventVisibleEls.forEach(el => el.textContent = visibleCount);

        progressBar.style.width = (visibleCount/data.totalMatching*100) + '%';

        if (loadMoreBtn && visibleCount >= data.totalMatching) {
            loadMoreBtn.style.display = 'none';
        } else if (loadMoreBtn) {
            loadMoreBtn.style.display = 'inline-block';       
        }
        eventListFooter.classList.remove('hidden');
    };

    fetchPage.handleSlider = function (data) {

        if (window.eventSlider == undefined || !document.getElementsByClassName('subpagehero').length) {
            return;
        }
        let el = document.getElementsByClassName('subpagehero');
        let i = 1;
        let html = '';
        let htmlFooter = '';

        data.items.forEach(hit => {
            if (i < 4) {
                html += `<div class="${(i == 1) ? 'current' : ''}">${eventListTemplate.getHitTemplate(hit, hit.url, true)}</div>`;
                htmlFooter += `<a data-index="${i}" class="${(i == 1) ? 'selected' : ''}">${hit.name}</a>`;
            }
            i++;
        });        

        if (el.length) {
            let elFirst = el[0].querySelector('.subpagehero-content');
            elFirst.innerHTML = `${html}<div class='event-hero__footer'><div class='event-hero__footer-nav'>${htmlFooter}</div><button class="event-hero__pause-btn" aria-label="Pause"></button></div>`;
            elFirst.classList.add('event-hero');
            if (el[0].classList.contains('subpagehero--white-text')) {
                elFirst.classList.add('event-hero--white-text');
            }
            el[0].classList.add('eventlist-hero-container');
            addHeroEvents(elFirst);
            repositionPauseButton(elFirst);
            setMobileHeroHeight(el[0]);
        }

    };

    fetchPage(false);

    function addDynamicFilters(facets) {
        const categoryFilter = eventblock.querySelector('.js-filtercategories');
        const catFacets  = facets.find(f => f.name === 'EventCategories');
        const typeFacets = facets.find(f => f.name === 'EventType');

        catFacets.items.forEach((facet, index) => {
            const id = `filter-${facet.term}`;
            const isHidden = index >= 10 ? ' style="display:none;"' : '';
            const hiddenClass = index >= 10 ? ' js-category-hidden' : '';
            categoryFilter.innerHTML += `<div class="filter-category-item${hiddenClass}"${isHidden}>
                <input type="checkbox" name="category" value="${facet.term}" id="${id}">
                <label for="${id}">${facet.term} (${facet.count})</label>
            </div>`;
        });

        // Add "Visa fler" link if there are more than 10 categories
        if (catFacets.items.length > 10) {
            categoryFilter.innerHTML += `<a href="#" class="js-toggle-categories filter-toggle-link">Visa alla</a>`;
        } 

        typeFacets.items.forEach((facet) => {
            if(facet.count > 0) {
                var hidden = eventblock.querySelector(`.js-filtertypes .hits-${facet.term}`);
                hidden.value = facet.count;   
            } 
        });
        
        eventblock.querySelectorAll(`.js-filtertypes .js-add-to-others`).forEach((hiddenAddFrom) => {
            eventblock.querySelectorAll(`.js-filtertypes .js-add-from-others`).forEach((hiddenAddTo) => {
                hiddenAddTo.value = parseInt(hiddenAddTo.value) + parseInt(hiddenAddFrom.value);
            });
        });

        eventblock.querySelectorAll(`.js-filtertypes label`).forEach((label) => {
            label.textContent += ` (${label.nextElementSibling.value})`;
        });

    }

    function updateClearFilterVisibility() {
        const clearFilterLink = eventblock.querySelector('a.js-clearfilter');
        if (clearFilterLink) {
            const form = clearFilterLink.closest('.js-eventfilter, form');
            if (form) {
                const checkedCheckboxes = form.querySelectorAll('input[type="checkbox"]:checked');
                if (checkedCheckboxes.length > 0) {
                    clearFilterLink.removeAttribute('hidden');
                } else {
                    clearFilterLink.setAttribute('hidden', '');
                }
            }
        }
    }

    function addEvents() {
        const filterInputs = eventblock.querySelectorAll('.js-eventfilter input');
        filterInputs.forEach(input => {
            input.addEventListener('click', (event) => {
                if(isLoading) {
                    event.preventDefault();
                } else {
                    updateClearFilterVisibility();
                    fetchPage(true);
                }
            });
        });

        if (loadMoreBtn) {
            loadMoreBtn.addEventListener('click', (event) => {
                event.preventDefault();
                fetchPage(false);
            });
        }
    
        const toggleSections = eventblock.querySelectorAll('.js-togglesortsection');
        toggleSections.forEach(section => {
            section.addEventListener('click', () => {
                const parent = section.parentElement;
                parent.classList.toggle('expanded');
            });
        });

        const mobileFilterTogglers = eventblock.querySelectorAll('.js-togglefilter-mobile');    
        mobileFilterTogglers.forEach(t => {
            t.addEventListener('click', () => {
                document.documentElement.classList.toggle('menu-open');
                eventblock.querySelector('.event-block__filter').classList.toggle('event-block__filter--mobileopen'); 
            });
        });

        eventblock.querySelector('.js-resetform').addEventListener('click', () => {
            const form = eventblock.querySelector('.js-eventfilter');
            form.reset();
            fetchPage(true);
        });

        const clearFilterLink = eventblock.querySelector('a.js-clearfilter');
        if (clearFilterLink) {
            clearFilterLink.addEventListener('click', (event) => {
                event.preventDefault();
                const container = clearFilterLink.closest('.js-eventfilter, form');
                if (container) {
                    const checkboxes = container.querySelectorAll('input[type="checkbox"]');
                    checkboxes.forEach(checkbox => {
                        checkbox.checked = false;
                    });
                    updateClearFilterVisibility();
                    fetchPage(true);
                }
            });
        }

        updateClearFilterVisibility();

        // Handle category toggle (Visa fler/färre)
        const categoryToggle = eventblock.querySelector('.js-toggle-categories');
        if (categoryToggle) {
            categoryToggle.addEventListener('click', (event) => {
                event.preventDefault();
                const hiddenCategories = eventblock.querySelectorAll('.js-category-hidden');
                const isExpanded = categoryToggle.textContent === 'Visa färre';

                hiddenCategories.forEach(cat => {
                    cat.style.display = isExpanded ? 'none' : 'block';
                });

                categoryToggle.textContent = isExpanded ? 'Visa fler' : 'Visa färre';
            });
        }
    }

    function repositionPauseButton(elFirst) {
        const pauseBtn = elFirst.querySelector('.event-hero__pause-btn');
        const footer = elFirst.querySelector('.event-hero__footer');
        if (!pauseBtn || !footer) return;

        function updatePosition() {
            const isMobile = window.innerWidth <= 767;
            const currentSlide = elFirst.querySelector('.event-hero > div.current');

            if (isMobile && currentSlide) {
                const ctaArea = currentSlide.querySelector('.event-list__item--cta');
                if (ctaArea && !ctaArea.contains(pauseBtn)) {
                    ctaArea.appendChild(pauseBtn);
                }
            } else if (!footer.contains(pauseBtn)) {
                footer.appendChild(pauseBtn);
            }
        }

        updatePosition();
        window.addEventListener('resize', updatePosition);

        const observer = new MutationObserver(() => {
            if (window.innerWidth <= 767) updatePosition();
        });
        observer.observe(elFirst, {
            attributes: true,
            subtree: true,
            attributeFilter: ['class']
        });
    }

    function setMobileHeroHeight(heroContainer) {
        if (!heroContainer) return;

        const MOBILE_TOP_PAD = 48;
        const MOBILE_BOTTOM_PAD = 16;

        function updateHeight() {
            const isMobile = window.innerWidth <= 767;

            if (!isMobile) {
                heroContainer.style.height = '';
                return;
            }

            const eventHero = heroContainer.querySelector('.event-hero');
            if (!eventHero) return;

            const slideDivs = eventHero.querySelectorAll('.event-hero > div:not(.event-hero__footer)');
            if (!slideDivs.length) return;

            const footer = eventHero.querySelector('.event-hero__footer');
            const footerHeight = footer ? footer.offsetHeight : 0;

            let maxSlideHeight = 0;

            // Measure each slide's content. Non-current slides have their
            // .event-list__item set to display:none, so we temporarily flip
            // it to flex to get a real offsetHeight.
            slideDivs.forEach(slide => {
                const item = slide.querySelector('.event-list__item');
                const wasHidden = !slide.classList.contains('current');
                let restoreItemDisplay = null;

                if (wasHidden && item) {
                    restoreItemDisplay = item.style.display;
                    item.style.display = 'flex';
                }

                const height = slide.offsetHeight;
                if (height > maxSlideHeight) {
                    maxSlideHeight = height;
                }

                if (restoreItemDisplay !== null) {
                    item.style.display = restoreItemDisplay;
                }
            });

            if (maxSlideHeight > 0) {
                heroContainer.style.height =
                    (maxSlideHeight + footerHeight + MOBILE_TOP_PAD + MOBILE_BOTTOM_PAD) + 'px';
            }
        }

        updateHeight();

        let resizeTimeout;
        window.addEventListener('resize', () => {
            clearTimeout(resizeTimeout);
            resizeTimeout = setTimeout(updateHeight, 100);
        });
    }

    function addHeroEvents(elFirst) {
        const toggles = elFirst.querySelectorAll('.event-hero__footer a');
        const pauseBtn = elFirst.querySelector('.event-hero__pause-btn');
        const eventDivs = elFirst.querySelectorAll('.event-hero > div:not(.event-hero__footer)');
        let autoAdvanceInterval = null;
        let isPaused = false;

        // Function to advance to next slide
        function advanceSlide() {
            const currentDiv = elFirst.querySelector('.event-hero > div.current');
            const currentLink = elFirst.querySelector('.event-hero__footer a.selected');

            if (!currentDiv || !currentLink) return;

            // Find next slide (or loop back to first)
            let nextDiv = currentDiv.nextElementSibling;
            if (!nextDiv || nextDiv.classList.contains('event-hero__footer')) {
                nextDiv = eventDivs[0];
            }

            // Remove current classes
            eventDivs.forEach(div => div.classList.remove('current'));
            toggles.forEach(link => link.classList.remove('selected'));

            // Add current classes to next elements
            nextDiv.classList.add('current');
            const nextIndex = Array.from(eventDivs).indexOf(nextDiv) + 1;
            const nextLink = elFirst.querySelector(`.event-hero__footer a[data-index="${nextIndex}"]`);
            if (nextLink) {
                nextLink.classList.add('selected');
            }
        }

        // Start auto-advance
        function startAutoAdvance() {
            if (autoAdvanceInterval) return;
            autoAdvanceInterval = setInterval(advanceSlide, 5000);
        }

        // Stop auto-advance
        function stopAutoAdvance() {
            if (autoAdvanceInterval) {
                clearInterval(autoAdvanceInterval);
                autoAdvanceInterval = null;
            }
        }

        // Manual navigation click handlers
        toggles.forEach(section => {
            section.addEventListener('click', (event) => {
                const clickedLink = event.target;
                const index = clickedLink.getAttribute('data-index');

                // Remove 'selected' from all links and add to clicked link
                toggles.forEach(link => link.classList.remove('selected'));
                clickedLink.classList.add('selected');

                // Toggle 'current' class on divs based on index
                eventDivs.forEach((div, i) => {
                    if ((i + 1) == index) {
                        div.classList.add('current');
                    } else {
                        div.classList.remove('current');
                    }
                });

                // Reset auto-advance timer when manually navigating
                if (!isPaused) {
                    stopAutoAdvance();
                    startAutoAdvance();
                }
            });
        });

        // Pause button handler
        if (pauseBtn) {
            pauseBtn.addEventListener('click', () => {
                isPaused = !isPaused;

                if (isPaused) {
                    stopAutoAdvance();
                    pauseBtn.classList.add('playing');
                    pauseBtn.setAttribute('aria-label', 'Spela');
                } else {
                    startAutoAdvance();
                    pauseBtn.classList.remove('playing');
                    pauseBtn.setAttribute('aria-label', 'Pause');
                }
            });
        }

        // Start auto-advance on load
        startAutoAdvance();
    }

    function addHits(hits) {
        hits.forEach(hit => {
            firstHitId = firstHitId === null ? hit.url : firstHitId;
            eventList.insertAdjacentHTML('beforeend', eventListTemplate.getHitTemplate(hit, firstHitId, false));
        });
    }
})();
export const eventListSingle = (() => {

    if (window.singleEventList == undefined) {
        return;
    }

    window.singleEventList.forEach(singleList => {
        const html = eventListTemplate.getHitTemplate(singleList.list[0], null, false);
        let els = document.querySelectorAll(`[data-eventid="${singleList.id}"]`);
        els.forEach(el => {
            el.innerHTML = html;
        });
    });

})();